module.exports = __webpack_public_path__ + "static/media/cp-pelican2.e77a2429.jpg";